<template>
  <div class="flex items-center justify-center w-full md:w-auto">
    <SearchBar :query="query" @input="emit('searchChange', $event)" />
  </div>
</template>

<script setup>
import { SearchBar } from "@/Components/Search";

const emit = defineEmits(["searchChange"]);

defineProps({
  query: { type: String, default: "" },
});
</script>
